<template>
<div ref="el" data-component="DatePicker.vue" class="datepicker" :class="{ 'is-active': DisplayPicker, 'is-standalone': Standalone, 'is-fixed': !Standalone, 'is-disabled': Disabled }" tabindex="0" @click="TogglePicker">
	<label v-if="!Standalone" class="relative">
		<span class="sr-only">Pole wyboru daty</span>
		<input :value="Label" readonly aria-label="Wybierz datę" @click.stop>
		<div class="calendarSvg-container">
			<OIcon name="calendar"/>
		</div>
	</label>
	<div v-if="DisplayPicker || Standalone" class="datepicker-popup" @click.stop>
		<div v-if="ViewDate.YearView" class="datepicker-year-view">
			<div class="datepicker-header">
				<div class="p-1" :data-disabled="ViewDate.Y <= MinDate.Y" @click="ViewDate.Y--">
					<div class="arrow-left"/>
				</div>
				<div @click="ViewDate.YearView = false">
					{{ ViewDate.Y }}
				</div>
				<div class="p-1" :data-disabled="ViewDate.Y >= MaxDate.Y" @click="ViewDate.Y++">
					<div class="arrow-right"/>
				</div>
			</div>
			<div class="datepicker-list">
				<div v-for="(Month, i) in MonthNames" :key="i" @click="ViewDate.M = i + 1; CreateMonthView(); ViewDate.YearView = false;">
					{{ Month.substr(0, 3) }}
				</div>
			</div>
		</div>
		<div v-if="!ViewDate.YearView" class="datepicker-month-view">
			<div class="datepicker-header">
				<div
					class="p-1"
					:class="{ 'pointer-events-none opacity-25': !(ViewDate.Y > MinDate.Y || (ViewDate.Y === MinDate.Y && ViewDate.M > MinDate.M)) }"
					@click="Navigate(-1)"
				>
					<div class="arrow-left"/>
				</div>
				<div @click="ViewDate.YearView = true">
					{{ MonthNames[ViewDate.M - 1] }} {{ ViewDate.Y }}
				</div>
				<div
					class="p-1"
					:class="[ !(ViewDate.Y < MaxDate.Y || (ViewDate.Y === MaxDate.Y && ViewDate.M < MaxDate.M)) ? 'pointer-events-none opacity-25' : '']"
					@click="Navigate(1)"
				>
					<div class="arrow-right"/>
				</div>
			</div>
			<div class="datepicker-list">
				<div v-for="(Name, i) in DayNames" :key="'h' + i" class="is-header">
					{{ Name }}
				</div>
				<div v-for="(Day, i) in MonthView" :key="'i' + i" :class="{ 'is-navigatable': Day.Navigate, 'is-selected': Day.Selected, 'is-disabled': Day.Disabled }" :data-emblem="(Emblems||{})[Day.Y + ':' + Day.M + ':' + Day.D]" :data-day="Day.Y + ':' + Day.M + ':' + Day.D" @click="SelectDate(Day)">
					{{ Day.D }}
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za kontrolkę kalendarza i wyboru daty.
// @group Base Components | Forms
export default {
	name: 'DatePicker',
	props: {
		modelValue: {},
		Min: { default: '2021-14-05' },
		Max: { default: '2050-31-12' },
		Standalone: { default: false },
		Emblems: {},
		Disabled: { type: Boolean, default: false },
		Short: { type: Boolean, default: false },
	},
	emits: ['update:modelValue'],
	data() {
		return {
			Date: { D: 1, M: 1, Y: 2020 },
			ViewDate: { M: 12, Y: 2020, YearView: false },
			DayNames: ['pon', 'wto', 'śro', 'czw', 'pią', 'sob', 'nie'],
			MonthNames: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
			MonthView: [],
			DisplayPicker: false,
		};
	},
	computed: {
		Label() { return (new Date(this.modelValue)).toLocaleDateString('pl-PL', { day: 'numeric', month: this.Short ? 'short' : 'long', year: 'numeric' }); },
		MinDate() { return this.StringToDate(this.Min); },
		MaxDate() { return this.StringToDate(this.Max); },
	},
	watch: {
		modelValue(n) {
			const d = this.StringToDate(n);
			this.ViewDate = { M: d.M, Y: d.Y, YearView: false };
			this.Date = d;
			this.CreateMonthView();
		},
		Min() {
			this.CreateMonthView();
		},
		Max() {
			this.CreateMonthView();
		},
	},
	created() {
		if (this.modelValue) {
			const d = this.StringToDate(this.modelValue);
			this.Date = d;
			this.ViewDate = { M: d.M, Y: d.Y, YearView: false };
		}
		if (!this.modelValue) {
			this.$emit('update:modelValue', (new Date()).toISOString().split('T')[0]);
		} else {
			this.CreateMonthView();
		}
	},
	methods: {
		TogglePicker() {
			if (!this.Disabled) {
				this.DisplayPicker = !this.DisplayPicker;
			}
		},
		StringToDate(s) {
			if (!s) { return null; }
			s = s.split('-');
			return { D: Number(s[2]), M: Number(s[1]), Y: Number(s[0]) };
		},
		DateToString(d) {
			return `${d.Y}-${d.M > 9 ? d.M : `0${d.M}`}-${d.D > 9 ? d.D : `0${d.D}`}`;
		},
		SelectDate(d) {
			this.$emit('update:modelValue', this.DateToString(d));
			window.setTimeout(() => { this.DisplayPicker = false; }, 50);
		},
		Navigate(n) {
			const vd = this.ViewDate;
			const [m, y] = this.SwitchDate(n, vd.M, vd.Y);
			vd.M = m; vd.Y = y;
			this.ViewDate = vd;
			this.CreateMonthView();
		},
		SwitchDate(n, m, y) {
			if (n < 0) { y = m < 2 ? (y - 1) : y; m = m < 2 ? 12 : (m - 1); }
			if (n > 0) { y = m > 11 ? (y + 1) : y; m = m > 11 ? 1 : (m + 1); }
			return [m, y];
		},
		DaysInMonth(m, y) {
			const leap = (((y % 4) === 0) && ((y % 100) !== 0)) || ((y % 400) === 0);
			return ([31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31])[m - 1];
		},
		IsDateInRange(d) {
			const min = this.MinDate;
			const max = this.MaxDate;
			const disabledMin = d.Y < min.Y || (d.Y === min.Y && d.M < min.M) || (d.Y === min.Y && d.M === min.M && d.D < min.D);
			const disabledMax = d.Y > max.Y || (d.Y === max.Y && d.M > max.M) || (d.Y === max.Y && d.M === max.M && d.D > max.D);
			return !disabledMin && !disabledMax;
		},
		CreateMonthView() {
			const dayOfWeek = (x) => ((x === 0) ? 6 : x - 1);
			const month = this.ViewDate.M; const year = this.ViewDate.Y;
			let p = dayOfWeek(new Date(`${year}/${month}/1`).getDay());
			const c = this.DaysInMonth(month, year);
			let f = (6 * 7) - (p + c);
			const pastDaysInMonth = this.DaysInMonth(month < 2 ? 12 : (month - 1), month < 2 ? (year - 1) : year);

			const result = [];
			const dd = (n, d, m, y) => {
				const sd = this.Date;
				[m, y] = this.SwitchDate(n, m, y);
				const isSelected = (sd.Y === y && sd.M === m && sd.D === d);
				result.push({
					Navigate: n, D: d, M: m, Y: y, Disabled: !this.IsDateInRange({ D: d, M: m, Y: y }), Selected: isSelected,
				});
			};

			if (!p) { p = +7; f -= 7; }

			for (let i = 0; i < p; i++) { dd(-1, pastDaysInMonth - i, month, year); } result.reverse();
			for (let i = 0; i < c; i++) { dd(0, i + 1, month, year); }
			for (let i = 0; i < f; i++) { dd(1, i + 1, month, year); }

			this.MonthView = result;
			return result;
		},
	},
};

</script>

<style lang="scss">
.is-active {
	.datepicker-popup {
		position: absolute;
		z-index: 2;
	}
}

.datepicker {
	z-index: 1;
	width: 182px;
	outline: none !important;

	input {
		padding: 0;
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
		pointer-events: none;
		text-align: center;
		touch-action: none;
	}

	.relative {
		display: flex;

		.calendarSvg-container {
			display: flex;
			width: 40px;
			align-items: center;
			justify-content: center;
			border: 1px solid #ccc;
			border-left: none;
			background-color: #f3f4f7;
			border-radius: 0 4px 4px 0;
		}
	}
}

.datepicker:not(.is-disabled) {
	.relative {
		cursor: pointer;
	}

	&:hover input { color: var(--accent); }
}

.datepicker-popup {
	position: absolute;
	top: 0;
	right: 0;
	width: 240px;
	height: 240px;
	padding: 12px;
	border-radius: 4px;
	box-shadow: 0 10px 24px 0 rgb(0 0 0 / 16%);
	text-align: center;
	user-select: none;
	white-space: normal;
}

.datepicker.is-fixed {
	.datepicker-popup {
		position: fixed;
		top: 50%;
		left: 50%;
		box-shadow: 0 10px 24px 0 rgb(0 0 0 / 16%), 0 0 0 100vmax rgb(0 0 0 / 15%);
		transform: translate(-50%, -50%);
		background: white;
	}

	&.is-active::before {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		content: '';
	}
}

.datepicker.is-fixed.is-active::before {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	content: '';
}

.datepicker.is-standalone .datepicker-popup {
	position: static;
	box-shadow: none;
}

.datepicker .is-header {
	color: inherit !important;
	font-weight: bold;
}

.datepicker .is-navigatable {
	opacity: 0.5;
}

.datepicker .datepicker-list {
	display: flex;
	flex-wrap: wrap;
}

.datepicker-list > div {
	flex: 0 0 calc(100%/7);
	line-height: 28px;
}

.datepicker-list .is-selected {
	background: var(--accent);
	border-radius: 128px;
	color: white !important;
	font-weight: bold;
}

.datepicker-list .is-disabled {
	color: var(--dark) !important;
	opacity: 0.25;
	pointer-events: none;
}

.datepicker-list > div:hover {
	color: var(--accent);
	cursor: pointer;
}

.datepicker-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.arrow-left {
	width: 0;
	height: 0;
	border-width: 4px 6.9px 4px 0;
	border-style: solid;
	border-color: transparent #000 transparent transparent;
}

.arrow-right {
	width: 0;
	height: 0;
	border-width: 4px 0 4px 6.9px;
	border-style: solid;
	border-color: transparent transparent transparent #000;
}

.datepicker-header div[data-disabled] {
	opacity: 0;
	pointer-events: none;
}

.datepicker-year-view .datepicker-list > div {
	flex: 0 0 calc(100%/3);
	line-height: 48px;
}

.datepicker.is-active {
	z-index: 65555;
}
</style>
